import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { MaybeIdentityX, MaybeIdentityY } from '../transform';
import { LinkArc, LinkShape, LinkSmooth, LinkVHV } from '../shape';
import { baseGeometryChannels, basePostInference, basePreInference, createBandOffset, tooltip2d } from './utils';
var shape = {
  link: LinkShape,
  arc: LinkArc,
  smooth: LinkSmooth,
  vhv: LinkVHV
};
/**
 * Connect `start` to `end` with single line.
 */
export var Link = function Link(options) {
  return function (index, scale, value, coordinate) {
    var X = value.x,
      Y = value.y,
      _value$x = value.x1,
      X1 = _value$x === void 0 ? X : _value$x,
      _value$y = value.y1,
      Y1 = _value$y === void 0 ? Y : _value$y;
    var offset = createBandOffset(scale, value, options);
    var P = index.map(function (i) {
      return [coordinate.map(offset([+X[i], +Y[i]], i)), coordinate.map(offset([+X1[i], +Y1[i]], i))];
    });
    return [index, P];
  };
};
Link.props = {
  defaultShape: 'link',
  defaultLabelShape: 'label',
  composite: false,
  shape: shape,
  channels: [].concat(_toConsumableArray(baseGeometryChannels({
    shapes: Object.keys(shape)
  })), [{
    name: 'x',
    required: true
  }, {
    name: 'y',
    required: true
  }]),
  preInference: [].concat(_toConsumableArray(basePreInference()), [{
    type: MaybeIdentityY
  }, {
    type: MaybeIdentityX
  }]),
  postInference: [].concat(_toConsumableArray(basePostInference()), _toConsumableArray(tooltip2d()))
};